import React from 'react';

export default props => <h1 className="card-heading">{props['title']}</h1>;
